import { formatMoney } from "../../../utils";
export const MoneyCell = { align: "right", render: formatMoney };
